var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPwShowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00007 2.38278C6.21033 2.38278 7.24158 2.87099 8.06587 3.83326C8.38215 4.20295 8.61281 4.57937 8.76811 4.87442C8.83321 4.99788 8.83321 5.14505 8.76811 5.26852C8.61281 5.56357 8.3825 5.93998 8.06623 6.30932C7.24229 7.27194 6.21068 7.7598 5.00007 7.7598C3.78945 7.7598 2.75785 7.27159 1.93391 6.30932C1.61728 5.93928 1.38662 5.56251 1.23131 5.2671C1.16586 5.14293 1.16728 4.9947 1.23273 4.87052C1.3799 4.59175 1.59534 4.23868 1.89004 3.88526C2.72141 2.88797 3.76752 2.38208 5.00007 2.38208M5.00007 1.25C2.0319 1.25071 0.600532 3.55731 0.109847 4.58609C-0.0366156 4.89281 -0.0366156 5.24977 0.109847 5.55685C0.600178 6.58562 2.03119 8.89223 5.00007 8.89223C7.96894 8.89223 9.39995 6.58562 9.89029 5.55685C10.0367 5.24977 10.0364 4.89317 9.89029 4.58609C9.3996 3.55731 7.96823 1.25071 5.00007 1.25071V1.25Z",
    fill: "#00725D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99977 3.97477C5.60437 3.97477 6.09647 4.46687 6.09647 5.07147C6.09647 5.67607 5.60437 6.16817 4.99977 6.16817C4.39517 6.16817 3.90307 5.67607 3.90307 5.07147C3.90307 4.46687 4.39517 3.97477 4.99977 3.97477ZM4.99977 2.84269C3.76899 2.84269 2.771 3.84069 2.771 5.07147C2.771 6.30225 3.76899 7.30024 4.99977 7.30024C6.23055 7.30024 7.22855 6.30225 7.22855 5.07147C7.22855 3.84069 6.23055 2.84269 4.99977 2.84269Z",
    fill: "#00725D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwShowIcon);
export default __webpack_public_path__ + "static/media/PwShowIcon.9204fbb01ebdded30e8cd456aa76cff6.svg";
export { ForwardRef as ReactComponent };